import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8fafc] py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-md w-full space-y-6 text-center">
        <div className="space-y-3">
          <div className="inline-flex items-center gap-2 bg-white border border-slate-200 px-3 py-1 rounded-full text-xs text-slate-600 shadow-xs">
            <span className="w-2 h-2 rounded-full bg-slate-400"></span>
            <span className="font-bold tracking-widest text-slate-900 uppercase text-[11px]">
              SPACELABS
            </span>
            <span className="text-slate-300">•</span>
            <span className="text-blue-700 font-mono font-medium text-[10px]">VIGILANCE AI</span>
          </div>

          <h1 className="font-display text-6xl sm:text-7xl font-semibold text-slate-900 tracking-tight">
            404
          </h1>
          <p className="font-display text-xl sm:text-2xl font-semibold text-slate-900 tracking-tight">
            Page not found
          </p>
          <p className="text-xs text-slate-500 max-w-xs mx-auto leading-relaxed">
            The regulatory signal or page you are looking for does not exist or may have been moved.
          </p>
        </div>

        <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-xs">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white text-xs font-semibold px-5 py-2.5 rounded-lg transition focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
